// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Logo & Description */}
        <div className={styles.footerBrand}>
          <div className={styles.footerLogo}>
            <img src={require('../../../assets/logo_1.png')} alt="MangaShelf" style={{width:36,height:36,borderRadius:8,objectFit:'contain'}} />
            <span className={styles.footerBrandName}>Manga<span className={styles.footerBrandAccent}>Shelf</span></span>
          </div>
          <p className={styles.footerDescription}>
            {t('footer.tagline')}<br />
            {t('footer.taglineSub')}
          </p>
          <p className={styles.footerLove}>
            {t('footer.madeWith')}
          </p>
        </div>

        {/* Footer Links Grid */}
        <div className={styles.footerLinks}>
          {/* Project Column */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerColumnTitle}>{t('footer.project')}</h4>
            <NavLink to="/about" className={styles.footerLink}>{t('footer.about')}</NavLink>
            <NavLink to="/docs" className={styles.footerLink}>{t('footer.docs')}</NavLink>
            <NavLink to="/contact" className={styles.footerLink}>{t('footer.contact')}</NavLink>
            <a href="https://github.com/KilianJATO/MangaOrganisation/releases" className={styles.footerLink} target="_blank" rel="noopener noreferrer">
              {t('footer.releaseNotes')}
            </a>
          </div>

          {/* Community Column */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerColumnTitle}>{t('footer.community')}</h4>
            <a href="https://github.com/KilianJATO/MangaOrganisation" className={styles.footerLink} target="_blank" rel="noopener noreferrer">
              {t('footer.github')}
            </a>
            <a href="https://discord.gg/b58djNSSQb" className={styles.footerLink} target="_blank" rel="noopener noreferrer">
              {t('footer.discord')}
            </a>
            <a href="https://ko-fi.com/mangashelf" className={styles.footerLink} target="_blank" rel="noopener noreferrer">
              {t('footer.kofi')}
            </a>
            <a href="https://status.mangashelf.app" className={styles.footerLink} target="_blank" rel="noopener noreferrer">
              {t('footer.status')}
            </a>
          </div>

          {/* Legal Column */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerColumnTitle}>{t('footer.legal')}</h4>
            <NavLink to="/impressum" className={styles.footerLink}>{t('footer.impressum')}</NavLink>
            <NavLink to="/datenschutz" className={styles.footerLink}>{t('footer.privacy')}</NavLink>
            <NavLink to="/agb" className={styles.footerLink}>{t('footer.terms')}</NavLink>
          </div>
        </div>
      </div>

      {/* Spenden-Banner */}
      <div className={styles.donationBanner}>
        <div className={styles.donationContent}>
          <div className={styles.donationText}>
            <span className={styles.donationHeart}>☕</span>
            <div>
              <strong>{t('footer.likeIt')}</strong>
              <p>{t('footer.likeItSub')}</p>
            </div>
          </div>
          <a
            href="https://ko-fi.com/mangashelf"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.donationButton}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            {t('footer.donate')}
          </a>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className={styles.footerBottom}>
        <div className={styles.footerBottomContent}>
          <p className={styles.copyright}>
            {t('footer.copyright', { year: new Date().getFullYear() })} <a href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noopener noreferrer">CC BY-SA 4.0</a> · <NavLink to="/datenschutz">{t('footer.privacy')}</NavLink>
          </p>
          <a href="https://github.com/KilianJATO/MangaOrganisation" className={styles.sourceCode} target="_blank" rel="noopener noreferrer">
            {t('footer.sourceCode')}
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
